import React, { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import useVerifyStyles from './verify.styles'
import { MFADialog } from './mfa'
import { triggetOTP, validateOTL } from '../../services/identity-service'
import PublicWrapper from '../public-wrapper/public-wrapper'
import { useDispatch } from 'react-redux'
import { invalidOTLAction } from '../../stores/user/user-action'
import { useInvalidOTL } from '../../stores/user/user.hooks'
import { getBrowserCDDC } from '../../utils/identity-utils'
import CustomLoading from '../custom/custom-loading'
import { setMedalliaUserProfile } from '../../utils/medallia-utils'

interface VerifyProps {
    message?: string
}
export const Verify: React.FC<VerifyProps> = () => {
    const classes = useVerifyStyles()

    const [loading, setLoading] = useState<any>()
    const [identity, setIdentity] = useState<any>(null)
    const [showMFAPopup, setShowMFAPopup] = useState<boolean>(false)
    const [theme, setTheme] = useState<boolean>(true)

    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const otlToken = params.get('token')
    const dispatch = useDispatch()

    const invalidOTL = useInvalidOTL()

    const validateOtl = async (otlToken: string) => {
        if (otlToken) {
            setLoading(true)
            try {
                const idResponse = await validateOTL(otlToken)
                if (idResponse) {
                    setIdentity(idResponse)
                    await triggerOtp(idResponse)
                    setLoading(false)
                    setMedalliaUserProfile({
                        firstName: idResponse?.firstName,
                        lastName: idResponse?.lastName,
                        email: idResponse?.contactInformation?.email
                    })
                }
            } catch (e) {
                dispatch(invalidOTLAction(true))
                setLoading(false)
            }
        }
    }

    useEffect(() => {
        validateOtl(otlToken)
        handleResize()
    }, [otlToken])

    const handleResize = () => {
        setTheme(window.innerWidth > 720)
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize)
    })

    const triggerOtp = async (identity) => {
        const resp = await triggetOTP(
            otlToken,
            identity.idToken,
            identity.contactInformation.phoneNumber1.countryCode,
            identity.contactInformation.phoneNumber1.number,
            getBrowserCDDC()
        )
        if (resp) {
            setShowMFAPopup(true)
        }
    }

    return (
        <PublicWrapper darkTheme={theme} backgroundClass={classes.tealBlueBg} displayPrivacyPolicyFooter={false}>
            <div className={classes.wrapper}>
                {loading && <CustomLoading message="Loading..." />}
                {invalidOTL && <Navigate to="/welcome" />}
                <MFADialog
                    showMFAPopup={showMFAPopup}
                    setShowMFAPopup={setShowMFAPopup}
                    idToken={identity?.idToken}
                    otlToken={otlToken}
                    phoneNumber={identity?.contactInformation.phoneNumber1}
                />
            </div>
        </PublicWrapper>
    )
}
